export const GET_UC_CREDENTIALS = 'GET_UC_CREDENTIALS';

export const getUcCredentials = () => ({ type: GET_UC_CREDENTIALS });
